import {
  MetricPerformanceKey,
  metricPerformanceRecord,
  MetricTagKey,
  InvokeSource,
} from './record/metricPerformanceRecord';
import { syncCheckMetricsScene, asyncCheckMetricsScene } from './checkMetricsScene';
import { isDetailPage } from '@meego/models/src/utils/isDetailPage';

function loadPrefetchFile(invokeSource: InvokeSource) {
  import(
    /* webpackChunkName: "metrics-lifecycle-prefetch" */
    './metricsLifecyclePrefetch'
  ).then(() => {
    metricPerformanceRecord.recordPerformance(
      MetricPerformanceKey.METRIC_LIFECYCLE_PREFETCH_ASYNC_RESOURCE_LOAD_END,
      performance.now(),
    );
    metricPerformanceRecord.recordTag(MetricTagKey.METRIC_LIFECYCLE_INVOKE_SOURCE, invokeSource);
  });
}

export function metricsSceneEventListener(invokeSource = InvokeSource.BASE) {
  metricPerformanceRecord.recordPerformance(
    MetricPerformanceKey.METRIC_LIFECYCLE_START,
    performance.now(),
  );

  const syncCheckRes = syncCheckMetricsScene();
  if (syncCheckRes) {
    metricPerformanceRecord.recordPerformance(
      MetricPerformanceKey.METRIC_LIFECYCLE_PREFETCH_START_SYNC,
      performance.now(),
    );
    loadPrefetchFile(invokeSource);
  } else {
    asyncCheckMetricsScene(() => {
      metricPerformanceRecord.recordPerformance(
        MetricPerformanceKey.METRIC_LIFECYCLE_PREFETCH_START,
        performance.now(),
      );
      loadPrefetchFile(invokeSource);
    });
  }
}

export const prefetchMiniWorkItem = () => {
  if (isDetailPage(window.location.pathname) && window.__MEEGO_TEMPLATE_TYPE__ === 'static') {
    performance.mark('detail_minimal_info_start');
    window.detail_mini_promise = fetch('/goapi/v5/workitem/v1/minimal_info')
      .then(res => res.json())
      .then(prefetchRes => {
        performance.mark('detail_minimal_info_end');
        window.DetailMinimalInfoWorkItem = prefetchRes?.data?.value || {};
        return prefetchRes;
      });
  }
};
